import styled from "styled-components";

export const DiscountFiledWithUnitsStyled = styled.div`
  .label {
    margin-bottom: 8px;
    height: 23px;
  }
  .internal {
    display: flex;

    .left-btn {
      button {
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        border: 1px solid #080425;
      }
    }

    .right-btn {
      button {
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        border: 1px solid #080425;
      }
    }

    .MuiInputBase-root {
      border-radius: 0px !important;
    }
  }
`;
